import * as _ from 'lodash';
import { fromJS } from 'immutable';

import { fetchingState } from '@constants';
import * as actions from '../actions/electronicRequest';
import { SUCCESS, START, ERROR } from '../actions/global';

const initialStats = {
  electronicRequests: { data: [], state: null },
  electronicRequestsAgent: { data: [], state: null },
  electronicRequestConfig: {
    statuses: [],
    methods: [],
  },
  pagination: {
    count: 0,
    page: 1,
    rowsPerPage: 50,
    rowsPerPageOptions: [50, 100, 200, 500],
    filter: {},
  },
  paginationAgent: {
    count: 0,
    page: 1,
    rowsPerPage: 50,
    rowsPerPageOptions: [50, 100, 200, 500],
    filter: {},
  },
  electronicRequestDetail: { data: {}, state: null },
  electronicRequestStatusCodes: { data: [], state: null },
  electronicRequestDetailAgent: { data: {}, state: null },
};

export default (state = fromJS(initialStats), action) => {
  switch (action.type) {
    case actions.FETCH_ELECTRONIC_REQUEST_STATUS_CODES[START]: {
      return state.setIn(
        ['electronicRequestStatusCodes', 'state'],
        fetchingState.FETCHING,
      );
    }
    case actions.FETCH_ELECTRONIC_REQUEST_STATUS_CODES[SUCCESS]: {
      return state
        .setIn(['electronicRequestStatusCodes', 'state'], fetchingState.LOADED)
        .setIn(
          ['electronicRequestStatusCodes', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case actions.FETCH_ELECTRONIC_REQUEST_STATUS_CODES[ERROR]: {
      return state.setIn(
        ['electronicRequestStatusCodes', 'state'],
        fetchingState.ERROR,
      );
    }

    case actions.ELECTRONIC_REQUEST_SEARCH[START]: {
      return state
        .setIn(['electronicRequests', 'data'], fromJS([]))
        .setIn(['electronicRequests', 'state'], fetchingState.FETCHING);
    }
    case actions.ELECTRONIC_REQUEST_SEARCH[SUCCESS]: {
      return state
        .setIn(['electronicRequests', 'state'], fetchingState.LOADED)
        .setIn(
          ['electronicRequests', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        )
        .setIn(['pagination', 'count'], action.data.totalRecords);
    }
    case actions.ELECTRONIC_REQUEST_SEARCH[ERROR]: {
      return state.setIn(['electronicRequests', 'state'], fetchingState.ERROR);
    }

    case actions.ELECTRONIC_REQUEST_AGENT_SEARCH[START]: {
      return state
        .setIn(['electronicRequestsAgent', 'data'], fromJS([]))
        .setIn(['electronicRequestsAgent', 'state'], fetchingState.FETCHING);
    }
    case actions.ELECTRONIC_REQUEST_AGENT_SEARCH[SUCCESS]: {
      return state
        .setIn(['electronicRequestsAgent', 'state'], fetchingState.LOADED)
        .setIn(
          ['electronicRequestsAgent', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        )
        .setIn(['paginationAgent', 'count'], action.data.totalRecords);
    }
    case actions.ELECTRONIC_REQUEST_AGENT_SEARCH[ERROR]: {
      return state.setIn(['electronicRequestsAgent', 'state'], fetchingState.ERROR);
    }

    case actions.FETCH_ELECTRONIC_REQUEST_DETAIL[START]: {
      return state
        .setIn(['electronicRequestDetail', 'data'], fromJS([]))
        .setIn(['electronicRequestDetail', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_ELECTRONIC_REQUEST_DETAIL[SUCCESS]: {
      return state
        .setIn(['electronicRequestDetail', 'state'], fetchingState.LOADED)
        .setIn(
          ['electronicRequestDetail', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        );
    }
    case actions.FETCH_ELECTRONIC_REQUEST_DETAIL[ERROR]: {
      return state.setIn(
        ['electronicRequestDetail', 'state'],
        fetchingState.ERROR,
      );
    }

    case actions.FETCH_ELECTRONIC_REQUEST_DETAIL_AGENT[START]: {
      return state
        .setIn(['electronicRequestDetailAgent', 'data'], fromJS({}))
        .setIn(['electronicRequestDetailAgent', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_ELECTRONIC_REQUEST_DETAIL_AGENT[SUCCESS]: {
      return state
        .setIn(['electronicRequestDetailAgent', 'state'], fetchingState.LOADED)
        .setIn(
          ['electronicRequestDetailAgent', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        );
    }
    case actions.FETCH_ELECTRONIC_REQUEST_DETAIL_AGENT[ERROR]: {
      return state.setIn(
        ['electronicRequestDetailAgent', 'state'],
        fetchingState.ERROR,
      );
    }

    case actions.FETCH_ELECTRONIC_REQUEST_STATUS_CONFIGS[SUCCESS]: {
      return state.setIn(
        ['electronicRequestConfig', 'statuses'],
        fromJS(_.get(action, 'data.results', [])),
      );
    }

    case actions.FETCH_ELECTRONIC_REQUEST_METHODS[SUCCESS]: {
      return state.setIn(
        ['electronicRequestConfig', 'methods'],
        fromJS(_.get(action, 'data', [])),
      );
    }

    case actions.CHANGE_PAGE: {
      return state.setIn(['pagination', 'page'], action.payload);
    }
    case actions.CHANGE_ROWS_PER_PAGE: {
      return state.setIn(['pagination', 'rowsPerPage'], action.payload);
    }
    case actions.CHANGE_FILTER: {
      return state.setIn(['pagination', 'filter'], action.payload);
    }
    case actions.CHANGE_PAGE_AGENT: {
      return state.setIn(['paginationAgent', 'page'], action.payload);
    }
    case actions.CHANGE_ROWS_PER_PAGE_AGENT: {
      return state.setIn(['paginationAgent', 'rowsPerPage'], action.payload);
    }
    case actions.CHANGE_FILTER_AGENT: {
      return state.setIn(['paginationAgent', 'filter'], action.payload);
    }
    default: {
      return state;
    }
  }
};
